import { render } from "./TaskPicker.vue?vue&type=template&id=05708de0&scoped=true"
import script from "./TaskPicker.vue?vue&type=script&lang=js"
export * from "./TaskPicker.vue?vue&type=script&lang=js"

import "./TaskPicker.vue?vue&type=style&index=0&id=05708de0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05708de0"]])

export default __exports__